import { ShieldCheck } from "lucide-react";
import { benefits } from "../data/homepageData";

export default function BenefitsSection() {
  return (
    <section className="rz-section rz-section--paper">
      <div className="rz-shell rz-benefits-layout">
        <div>
          <p className="rz-kicker rz-kicker--dark">Avantaje</p>
          <h2>De ce merită să ai un sistem propriu pentru rezervări sau programări directe</h2>
          <p>
            Când informațiile sunt clare și cererile ajung într-un flux mai organizat, businessul tău inspiră mai multă încredere și răspunde mai simplu la interesul existent.
          </p>
        </div>

        <div className="rz-benefits-list">
          {benefits.map((item) => (
            <div key={item.title} className="rz-benefit-item">
              <h3 className="rz-benefit-title">
                <ShieldCheck size={18} /> {item.title}
              </h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>

        <aside className="rz-commission-card">
          <span>Rezervix</span>
          <strong>Mai puțin haos. Mai mult control.</strong>
          <p>
            Nu înlocuiește promovarea. O completează cu o prezentare profesionistă și cu un mod mai clar prin care clientul poate trimite o cerere direct către tine.
          </p>
        </aside>
      </div>
    </section>
  );
}
